import { lazy } from "react";
import RenderSubSection from "./RenderSubSections";

const ShelfList = lazy(() => import("pages/PickPack/pages/shelf/List"));
const ShelfForm = lazy(() => import("pages/PickPack/pages/shelf/form"));

// const PickScan = lazy(() => import("pages/PickPack/pages/pick/Scan"));
const OrderAction = lazy(() => import("pages/PickPack/pages/action/Scan"));

// const PickLocation = lazy(() => import("pages/PickPack/pages/pick/List"));
//
// const PackScan = lazy(() => import("pages/PickPack/pages/pack/Scan"));
// const PackLocation = lazy(() => import("pages/PickPack/pages/pack/List"));

//Shelf
const shelfList = {
    name: "لیست قفسه‌ها",
    path: "/shelf-list",
    group: "shelf-list",
    exact: true,
    component: () => <ShelfList />,
};

const shelfNew = {
    name: "ایجاد قفسه جدید",
    path: "/new-shelf",
    group: "new-shelf",
    isHide: true,
    component: () => <ShelfForm />,
};
const shelfUpdate = {
    name: "ویرایش قفسه",
    path: "/update-shelf/:id",
    group: "update-shelf",
    isHide: true,
    component: () => <ShelfForm />,
};

const shelfView = {
    name: "مشاهده قفسه",
    path: "/view-shelf/:id",
    group: "view-shelf",
    isHide: true,
    component: () => <ShelfForm />,
};

// const packScan = {
//     name: "تخصیص جا به سفارش",
//     path: "/pack-scan",
//     group: "pack-scan",
//     exact: true,
//     component: () => <PackScan />,
// };

// const packLocation = {
//     name: "تخصیص جا به سفارش",
//     path: "/pack-location",
//     group: "pack-location",
//     isHide: true,
//     component: () => <PackLocation />,
// };
//
// const pickScan = {
//     name: "برداشت سفارش",
//     path: "/pick-scan",
//     group: "pick-scan",
//     exact: true,
//     component: () => <PickScan />,
// };

// const pickLocation = {
//     name: "برداشت سفارش",
//     path: "/pick-location",
//     group: "pick-location",
//     isHide: true,
//     component: () => <PickLocation />,
// };

const orderAction = {
    name: "عملیات سفارش",
    path: "/order-action",
    group: "order-action",
    component: () => <OrderAction />,
};

const subSections = {
    shelf: {
        list: { ...shelfList },
        create: { ...shelfNew },
        update: { ...shelfUpdate },
        view: { ...shelfView },
    },
    pack: {
        create: { ...orderAction}
    },
    // pack: {
    //     create: { ...packScan },
    //     list: { ...packLocation },
    // },
    // pick: {
    //     create: { ...pickScan },
    //     list: { ...pickLocation },
    // },
};

const HubOperation = {
    title: "عملیات هاب",
    key: "hubOperation",
    SubRoutes: (keywords: any) => RenderSubSection(keywords, subSections),
};
export default HubOperation;
